module.exports = __webpack_public_path__ + "img/noimage.c1ef534e.svg";